
import { useEffect, useState } from 'react';

interface NavbarProps {
  isMenuOpen: boolean;
  setIsMenuOpen: (value: boolean) => void;
}

export default function Navbar({ isMenuOpen, setIsMenuOpen }: NavbarProps) {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center">
            <a href="/" className="flex items-center space-x-2">
              <div className="w-10 h-10 bg-teal-500 rounded-lg flex items-center justify-center">
                <i className="ri-heart-pulse-line text-2xl text-white"></i>
              </div>
              <span className={`text-2xl font-bold ${isScrolled ? 'text-gray-900' : 'text-white'}`} style={{ fontFamily: 'Poppins, sans-serif' }}>
                Houston Health Insurance
              </span>
            </a>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <a href="#top-agencies" className={`text-sm font-medium hover:text-teal-500 transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Top Agencies
            </a>
            <a href="#why-choose" className={`text-sm font-medium hover:text-teal-500 transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Why Choose Us
            </a>
            <a href="#contact" className={`text-sm font-medium hover:text-teal-500 transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Contact
            </a>
            <a href="tel:2812062619" className="bg-teal-500 text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer">
              (281) 206-2619
            </a>
          </div>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 cursor-pointer"
          >
            <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-gray-900' : 'text-white'}`}></i>
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden bg-white border-t">
          <div className="px-4 py-4 space-y-3">
            <a href="#top-agencies" className="block text-sm font-medium text-gray-700 hover:text-teal-500 py-2">
              Top Agencies
            </a>
            <a href="#why-choose" className="block text-sm font-medium text-gray-700 hover:text-teal-500 py-2">
              Why Choose Us
            </a>
            <a href="#contact" className="block text-sm font-medium text-gray-700 hover:text-teal-500 py-2">
              Contact
            </a>
            <a href="tel:2812062619" className="block bg-teal-500 text-white px-6 py-2.5 rounded-lg text-sm font-medium text-center cursor-pointer">
              (281) 206-2619
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
